export const transitionProps = {
  timeout: 300,
  classNames: "fade",
};
